import React, { useState, useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link, useParams } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';

const SingleFrontOffice = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone_no: '',
    mobile_no: '',
    allowed_to_edit: false,
    status: true
  });

  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const fetchFrontOfficeUser = async () => {
      try {
        const response = await axios.get(
          `https://bmrbackend.dynastymaker.com/api/users/front-office/${id}`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        if (response.data.success) {
          const userData = response.data.data;
          setFormData({
            name: userData.name || '',
            email: userData.email || '',
            password: '********', // Masked password for display
            password_confirmation: '********', // Masked password for display
            phone_no: userData.phone_no || '',
            mobile_no: userData.mobile_no || '',
            allowed_to_edit: userData.allowed_to_edit || false,
            status: userData.status || true
          });
        } else {
          toast.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching front office user:', error);
        toast.error(error.response?.data?.message || 'Failed to fetch user data');
      } finally {
        setLoading(false);
      }
    };

    fetchFrontOfficeUser();
  }, [id]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  if (loading) {
    return (
      <div className="container py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          Front Office Information
        </div>
      </div>
      
      <div>
        <div className="card mb-4 shadow-sm">
          <div className="card-body row">
            <div className='text-end'>
                <Link to={`/super-admin/edit-front-office/${id}`} className='btn btn-primary '>Edit</Link>
            </div>
            <div className="mb-3 col-md-6 col-12">
              <label>Name</label>
              <input 
                type="text" 
                className="form-control" 
                name="name"
                value={formData.name}
                readOnly
                disabled
              />
            </div>
            <div className="col-md-6 col-12 mb-3">
              <label>Phone No</label>
              <input 
                type="text" 
                className="form-control" 
                name="phone_no"
                value={formData.phone_no}
                readOnly
                disabled
              />
            </div>
            <div className="col-md-6 col-12 mb-3">
              <label>Mobile No</label>
              <input 
                type="text" 
                className="form-control" 
                name="mobile_no"
                value={formData.mobile_no}
                readOnly
                disabled
              />
            </div>
            <div className="col-md-6 col-12 d-flex align-items-center mb-3">
              <div className='bg-light p-3 mt-4 w-100 rounded-3'>
                <input 
                  type="checkbox" 
                  name="allowed_to_edit"
                  checked={formData.allowed_to_edit}
                  readOnly
                  disabled
                />
                <label className='mx-2'>Allow to Edit Leads</label>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex align-items-center mt-3 justify-content-center'>
          <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
            Login Details
          </div>
        </div>

        <div className="card shadow-sm">
          <div className="card-body row">
            <div className="col-md-12 col-12 mb-3">
              <label>Email</label>
              <input 
                type="email" 
                className="form-control" 
                name="email"
                value={formData.email}
                readOnly
                disabled
              />
            </div>

          

            <div className="mt-3">
              <Link to={'/super-admin/front-office/view'} type="button" className="btn bg-light buttonadd">
                <IoArrowUndoSharp size={20} /> Back
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleFrontOffice;